import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";

type CreateWorkflowRequestResponse = {
    id: string;
    permissions: any;
    policies: Array<any>;
    policyConfigs: Array<any>;
    rpServices: Array<any>;
    selectedPolicies: Array<any>;
    workflow: any;
};

export const createWorkflowRequest = async (
    workflowName: string,
    workflowID: string,
    workflowTemplateID: string,
    workflowJSON: { [key: string]: any },
    relyingPartyID: string,
    rpServiceRedirects: Array<string>
): Promise<GenericNetworkResponse<CreateWorkflowRequestResponse>> => {

    const route = apiRoutes.serviceConfiguration.workflow.copy;
    const body = {
        workflowName: workflowName,
        workflowID: workflowID,
        workflowTemplateID: workflowTemplateID,
        workflow: workflowJSON,
        relyingPartyID: relyingPartyID,
        rpServiceRedirects: rpServiceRedirects?.join(",")
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};